import { render } from "./PassReservationContainer.vue?vue&type=template&id=3806a654&scoped=true"
import script from "./PassReservationContainer.vue?vue&type=script&lang=js"
export * from "./PassReservationContainer.vue?vue&type=script&lang=js"

import "./PassReservationContainer.vue?vue&type=style&index=0&id=3806a654&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3806a654"]])

export default __exports__